/*
 追従ヘッダーがある地点から要素を固定
 */
module.exports = function(scene){
    var $triggerElement = $(scene.triggerElement());
    var $postShare = $triggerElement.siblings('.l-post-inner').find('.post-share')

    scene.on('enter', function() {
        $postShare.removeClass('fixed');
        $postShare.addClass('tail');
    });

    scene.on('leave', function() {
        $postShare.addClass('fixed');
        $postShare.removeClass('tail');
    });
};



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/scene-postShareOut.js
 **/